module.exports = __webpack_public_path__ + "img/manual-grn-05-check-status.90e58bc2.png";